import "./App.css";
import VehicleRegistrationprevious from "../src/pages/VehicleRegistrationprevious/VehicleRegistrationprevious";
import VehicleRegistration from "../src/pages/VehicleRegistration/VehicleRegistration";
import UpdateUser from "../src/pages/UpdateUser/UpdateUser";
import AttendenceLog from "../src/pages/AttendenceLog/attendenceLog";
import Login from "../src/pages/Login/login";
import LiveAttendanceLogin from "../src/pages/LiveAttendanceLogin/LiveAttendanceLogin";
import GardView from "../src/pages/GardView/GardView";
import AttendentCard from "../src/pages/AttendentCard/AttendentCard";
import TimeEndorsement from "../src/pages/TimeEndorsement/TimeEndorsement";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import { ThemeProvider, CssBaseline } from "@mui/material";
import nocopsTheme from "./theme/muiTheme";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

function App() {
  return (
    <ThemeProvider theme={nocopsTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />}></Route>
          <Route path="/LiveAttendanceLogin" element={<LiveAttendanceLogin />}></Route>

          {/* Protected - require a successful login first */}
          <Route
            path="/AttendentCard"
            element={
              <ProtectedRoute>
                <AttendentCard />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="/GardView"
            element={
              <ProtectedRoute>
                <GardView />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="/vehicleRegistration"
            element={
              <ProtectedRoute>
                <VehicleRegistration />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="/VehicleRegistrationprevious"
            element={
              <ProtectedRoute>
                <VehicleRegistrationprevious />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="/attendenceLog"
            element={
              <ProtectedRoute>
                <AttendenceLog />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="/TimeEndorsement"
            element={
              <ProtectedRoute>
                <TimeEndorsement />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="/UpdateUser"
            element={
              <ProtectedRoute>
                <UpdateUser />
              </ProtectedRoute>
            }
          ></Route>

          <Route path="/" element={<Navigate to="/login" replace />}></Route>
          <Route path="/*" element={<Navigate to="/login" replace />}></Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
